"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CodeBlockProps {
  code: string;
  language?: string;
  filename?: string;
}

export function CodeBlock({ code, language = "bash", filename }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // clipboard может быть недоступен в HTTP-контексте — silently fail
    }
  }

  return (
    <div className="my-4 rounded-xl border border-stone-200 bg-stone-950 overflow-hidden">
      {(filename || language) && (
        <div className="flex items-center justify-between bg-stone-900 border-b border-stone-800 px-4 py-2">
          <div className="text-[11px] text-stone-400 font-mono">
            {filename ?? language}
          </div>
          <button
            onClick={handleCopy}
            className="text-stone-400 hover:text-stone-200 transition-colors text-[11px] inline-flex items-center gap-1.5"
          >
            {copied ? (
              <>
                <Check className="w-3 h-3" />
                Copiado
              </>
            ) : (
              <>
                <Copy className="w-3 h-3" />
                Copiar
              </>
            )}
          </button>
        </div>
      )}
      <pre className="overflow-x-auto p-4 text-xs sm:text-[13px] leading-relaxed text-stone-200 font-mono whitespace-pre">
        {code}
      </pre>
    </div>
  );
}
